import React from 'react';
import { connect } from 'react-redux';
import { defineMessages } from 'react-intl';
import { Helmet } from 'react-helmet';

import { getCurrentLangCode, getMessage } from '../reducers/i18n';

defineMessages({
    globalTitle: {
        id: 'GLOBAL_SITE_TITLE',
        defaultMessage: 'www.schnoffle.de | Näh Dir Dein Designerstück!',
    },
    globalDescritpion: {
        id: 'GLOBAL_SITE_DESCRIPTION',
        defaultMessage: '&quot;Näh Dir Dein Designerstück!&quot; ist unser Motto. Dafür bekommst Du Designer-Schnitt und Stoff im Näh-Paket. Das Besondere: Du gestaltest die Stoffe selbst. Alles wird nach Deinen Vorgaben hier in Deutschland bedruckt. Alles für perfekte Unikate.',
    },
});

const MetaData = props => (
    <Helmet
        htmlAttributes={{ lang: props.locale }}
    >
        <title >{props.title}</title >
        <meta property='og:title' content={props.title} />
        <meta property='og:locale' content={props.locale} />
        <meta property='og:type' content='website' />
        <meta property='og:url' content='https://www.schnoffle.de/' />
        <meta property='og:image'
              content='https://d1hifgxwzqc0jz.cloudfront.net/images/schnitt-stoff-schnoffle-v1.jpg' />
        <meta property='og:image:alt'
              content='Zeigt das Nähpaket (Schnoff) mit Schnittmuster und individuell eingefärbten Stoff.' />
        <meta property='og:image:type' content='image/jpeg' />
        <meta property='og:description' content={props.description} />
        <meta name='description' content={props.description} />
        <link rel='canonical' href='https://www.schnoffle.de/' />
        <link rel='alternate' hrefLang='en' href='https://www.schnoffle.de/en/' />
    </Helmet >
);

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const title = getMessage(initialState, 'GLOBAL_SITE_TITLE');
    const description = getMessage(initialState, 'GLOBAL_SITE_DESCRIPTION');
    const locale = getCurrentLangCode(initialState);
    return (state, ownProps) => ({
        title,
        locale,
        description,
    });
};

export default connect(makeMapStateToProps)(MetaData);



// WEBPACK FOOTER //
// ./src/components/MetaData.js